import { render, staticRenderFns } from "./PresupuestoForm.vue?vue&type=template&id=0609b00f"
import script from "./PresupuestoForm.vue?vue&type=script&lang=js"
export * from "./PresupuestoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports